import React, { useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import isString from 'lodash/isString';

import { ADGMPanel, ADGMResponsiveModal, ADGMImage } from 'aurora-components';
import { locationTitle } from 'aurora-utils/utils';
import { keyEmptyCheck } from 'aurora-utils/utils.js';
import isEmpty from 'lodash/isEmpty';
import Hidden from '@material-ui/core/Hidden';
import styles from './styles';

function PropertyUnitDetails(props) {
  const {
    classes,
    handleBtnClicked,
    locale,
    title,
    subtitle,
    mandatory,
    isSingleUnit,
    isMultipleUnits,
    propertyUnits,
    propertyDetail,
    btnText,
    disabledBtn,
    isRenewal,
    isAmendment,
  } = props;
  const [openModal, setOpenModal] = useState(false);
  // const isMultipleUnits = true;
  // const isSingleUnit = false;

  function UnitMultiple(unit) {
    const unitAddress =
      locale === 'en'
        ? `${unit?.municipalityNameEn || '~'}, ${unit?.districtNameEn || '~'}, ${unit?.communityNameEn || '~'}`
        : `${unit?.municipalityNameAr || '~'}, ${unit?.districtNameAr || '~'}, ${unit?.communityNameAr || '~'}`;

    return (
      <Box display='flex' width='100%' className={classes.propertyUnitCard}>
        <Box display='flex' alignItems='center'>
          <ADGMImage alt='property' name='LeaseUnit.svg' className={classes.propertyImage} />
          <Box className={classes.propertyContent}>
            <Typography variant='h6' component='h2' className={classes.title}>
              {`${unit?.unitNumber || ''}, ${unit?.buildingNumber || ''}`}
            </Typography>
            <Hidden smDown>
              <Typography className={classes.propertyInfo} variant='body1'>
                {unitAddress}
              </Typography>
            </Hidden>
            <Typography className={classes.propertyInfo} variant='body1'>
              {unit?.unitRegNumber}
            </Typography>
          </Box>
        </Box>
        {!(isRenewal || isAmendment) && (
          <Hidden smDown>
            <Button className={classes.textGrayLight} onClick={() => handleBtnClicked(unit?.plotId)}>
              {isString(btnText) ? keyEmptyCheck(btnText) : btnText}
            </Button>
          </Hidden>
        )}
        <Hidden mdUp>
          <Box display='flex' alignItems='center' justifyContent='space-between'>
            <Typography className={classNames(classes.propertyInfo, classes.propertyInfoMob)} variant='body1'>
              <ADGMImage name='Location.svg' alt='location' />
              {unitAddress}
            </Typography>
            {!(isRenewal || isAmendment) && (
              <Button
                className={classNames(classes.textGrayLight, classes.btnMob)}
                onClick={() => handleBtnClicked(unit?.plotId)}
              >
                {isString(btnText) ? keyEmptyCheck(btnText) : btnText}
              </Button>
            )}
          </Box>
        </Hidden>
      </Box>
    );
  }

  return (
    <Box className={classes.propertyUnitContainer}>
      <ADGMPanel title={title} subtitle={!(isRenewal || isAmendment) && subtitle} mandatory={mandatory}>
        {/* for single unit */}
        {isSingleUnit && (
          <Grid container spacing={3} alignItems='center' className={classes.initiateserviceSect}>
            <Grid item xs={8} className={classes.initiateservicedtaile}>
              <ADGMImage alt='property' name='LeaseUnit.svg' className={classes.propertyImage} />
              <Box className={classes.propertyContent}>
                <Typography variant='h6' component='h2' className={classes.title}>
                  {propertyDetail?.unitRegNum ||
                    propertyDetail?.unitRegistrationNumber + ', ' + propertyDetail?.buildingNumber}
                </Typography>

                <Box component={Typography} className={classes.propertyInfo} display='flex' variant='body1'>
                  <ADGMImage name='adgm-location.svg' alt='location' />
                  {locationTitle(propertyDetail, locale)}
                </Box>

                <Box
                  component={Typography}
                  display='flex'
                  variant='body1'
                  className={classNames(classes.propertyInfo, classes.propertyInfo2)}
                >
                  <Box display='flex'>
                    <ADGMImage name='dar-size.svg' alt='sizeIcon' />
                    {propertyDetail?.unitArea + ' '}
                  </Box>
                  <Box display='flex'>
                    <ADGMImage name='home-icon.svg' alt='homeIcon' />
                    {locale === 'en' ? propertyDetail?.unitUsageTypeEn + ' ' : propertyDetail?.unitUsageTypeAr + ' '}
                  </Box>
                  <Box display='flex'>
                    <ADGMImage name='adgm-bed.svg' alt='bedIcon' />
                    {propertyDetail?.bedroomCount}
                  </Box>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={4} align='right'>
              <Button className={classes.textGrayLight} onClick={handleBtnClicked} disabled={disabledBtn}>
                {isString(btnText) ? keyEmptyCheck(btnText) : btnText}
              </Button>
            </Grid>
          </Grid>
        )}
        {/* For Multiple units */}
        {isMultipleUnits && !isEmpty(propertyUnits) && propertyUnits?.slice(0, 3)?.map(unit => UnitMultiple(unit))}
        {/* view all btn */}
        {isMultipleUnits && propertyUnits?.length > 3 && (
          <Box onClick={() => setOpenModal(true)} className={classes.viewAll} py={4} textAlign='center'>
            {keyEmptyCheck('view_all')} ({propertyUnits?.length}) {keyEmptyCheck('units')}
            <span className={classes.arrowRight}>
              <svg width='10' height='16' viewBox='0 0 10 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M1.8002 14.4L8.20019 8.00003L1.80019 1.60003'
                  stroke='#1C999B'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </span>
          </Box>
        )}

        {/* Modal to show all selected Property */}
        {isMultipleUnits && propertyUnits?.length > 3 && (
          <ADGMResponsiveModal
            open={openModal}
            onClose={() => setOpenModal(false)}
            toggleModal={() => setOpenModal(false)}
            title={keyEmptyCheck('selected_property')}
            disablePortal
            customClasses={{ modal: classes.modal }}
          >
            <Box className={classes.propertyModalContainer}>{propertyUnits?.map(unit => UnitMultiple(unit))}</Box>
          </ADGMResponsiveModal>
        )}
      </ADGMPanel>
    </Box>
  );
}

PropertyUnitDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  propertyDetail: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  btnText: PropTypes.string,
  propertyUnits: PropTypes.array,
  handleBtnClicked: PropTypes.func,
  mandatory: PropTypes.bool,
  disabledBtn: PropTypes.bool,
  isSingleUnit: PropTypes.bool.isRequired,
  isMultipleUnits: PropTypes.bool.isRequired,
  isRenewal: PropTypes.bool,
  isAmendment: PropTypes.bool,
};

PropertyUnitDetails.defaultProps = {
  btnText: null,
  subtitle: null,
  mandatory: false,
  disabledBtn: false,
  propertyUnits: [],
  handleBtnClicked: () => {},
  isRenewal: false,
  isAmendment: false,
};

export default withStyles(styles)(PropertyUnitDetails);
